import { render, staticRenderFns } from "./DetailsComp.vue?vue&type=template&id=4a142721&scoped=true&"
import script from "./DetailsComp.vue?vue&type=script&lang=js&"
export * from "./DetailsComp.vue?vue&type=script&lang=js&"
import style0 from "./DetailsComp.vue?vue&type=style&index=0&id=4a142721&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a142721",
  null
  
)

export default component.exports